import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';

import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmailViewerModule } from '@vendasta/galaxy/email-viewer';
import { ConversationPipesModule } from '../../../../../../../pipes';
import DOMPurify from 'dompurify';

export interface EmailPreviewDialogData {
  htmlContent: string;
  textContent: string;
}

@Component({
  selector: 'inbox-email-preview',
  templateUrl: './email-preview.component.html',
  styleUrls: ['./email-preview.component.scss'],
  imports: [
    GalaxyPipesModule,
    MatDialogContent,
    MatDialogClose,
    MatDialogActions,
    MatButton,
    TranslateModule,
    GalaxyEmailViewerModule,
    ConversationPipesModule,
  ],
})
export class EmailPreviewDialogComponent {
  private readonly data = inject(MAT_DIALOG_DATA);
  dialogData: EmailPreviewDialogData = this.data;
  strippedHtmlContent: string = stripQueryParamsFromHtml(this.dialogData.htmlContent, SENSITIVE_EMAIL_PARAMS);

  constructor(public dialogRef: MatDialogRef<EmailPreviewDialogComponent>) {}

  // TODO(MEGA-1304): When extracting the email thread from the email body in the backend and saving it in the message.body, this field might not have the the original text content anymore. We will have to reconsider how to handle this
  get textContent(): string {
    return DOMPurify.sanitize(this.dialogData.textContent);
  }
}

const SENSITIVE_EMAIL_PARAMS = ['npsid', 'nps_id', 'net_promoter_score_id', 'netpromoterscoreid', 'score'];

export function stripQueryParamsFromHtml(html: string, params: string[]): string {
  if (!html || params.length === 0) return html;
  return html.replace(/href=(["'])([^"']*)\1/gi, (match, quote: string, url: string) => {
    const decoded = url.replace(/&amp;/g, '&');
    const hashIndex = decoded.indexOf('#');
    const fragment = hashIndex !== -1 ? url.substring(hashIndex) : '';
    const withoutFragment = hashIndex !== -1 ? decoded.substring(0, hashIndex) : decoded;
    const qIndex = withoutFragment.indexOf('?');
    if (qIndex === -1) return match;
    const base = withoutFragment.substring(0, qIndex);
    const query = withoutFragment.substring(qIndex + 1);
    const kept = query.split('&').filter((p) => !params.includes(p.split('=')[0].toLowerCase()));
    if (kept.length === 0) return `href=${quote}${base}${fragment}${quote}`;
    return `href=${quote}${base}?${kept.join('&amp;')}${fragment}${quote}`;
  });
}
